<template>
    <div>
        <gofix-card title="Work Order Info">
            <template slot="gofixCard:right_header">
                <template v-if="!IsReadOnly">
                    <button v-if="$checkRole(this.$accessModule.order_tabs.main_info, 'update')"
                            class="icon-button"
                            @click="modals.info.open = true">
                        <img width="20" src="img/iconPencil.png" alt="" />
                    </button>
                </template>
            </template>
            <b-row>
                <b-col md="9">
                    <b-row>
                        <b-col md="4" class="work-order-info-col-1">
                            <gofix-text-field class="mb-3" label="Service Category" oneline>{{ Item.service_category_name ? Item.service_category_name : '--' }}</gofix-text-field>
                        </b-col>
                        <b-col md="5" class="work-order-info-col-2">
                            <gofix-text-field class="mb-3" label="Fault Type" oneline>{{Item.fault_type ? Item.fault_type.fault_name : null}}</gofix-text-field>
                        </b-col>
                        <b-col md="3">
                            <gofix-text-field class="mb-3" label="Priority" oneline>{{Item.sla ? Item.sla.priority : null}}</gofix-text-field>
                        </b-col>
                        
                    </b-row>
                    <b-row>
                        <b-col md="4" class="work-order-info-col-1">
                            <gofix-text-field class="mb-3" label="Equipment Group" oneline>{{Item.equipment_type ? Item.equipment_type.name : null}}</gofix-text-field>
                        </b-col>
                        <b-col md="5" class="work-order-info-col-2">
                            <gofix-text-field class="mb-3  width-full" label="Equipment" oneline >
                                <ul class="list-equips-equipment">
                                    <template v-for="(eq, index) in Item.equipments" v-if="Item.equipments">
                                        <li v-if="index < 7">
                                            <span>{{eq.tag_name}}</span>
                                        </li>
                                        <li v-if="index === 7" @click="modals.showAllEquipment.open = true"><span>{{ Item.equipments.length - 7 }} +</span></li>
                                    </template>
                                </ul>
                                <template slot="gofixTextField:after_value">
                                    <gofix-button
                                            v-if="$checkRole(this.$accessModule.order_tabs.main_info, 'update') || $checkRole(this.$accessModule.order_tabs.main_info, 'create')"
                                            class="editRight equipmentPosition" label="Edit" @click="modals.editEquipment.open = true" noBorder fontNormal small ></gofix-button>
                                </template>
                            </gofix-text-field>
                        </b-col>
                        <b-col md="3" class="work-order-info-col-3">
                             <gofix-text-field class="mb-3 width-full" label="Unit No" oneline >{{ Item.cases ? Item.cases.unit_no : null}}</gofix-text-field>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3">
                        <b-col md="4" class="work-order-info-col-1">
                            <gofix-text-field label="Date Issued" oneline>{{ Item.order_issue_date ? Item.order_issue_date : null | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}</gofix-text-field>
                        </b-col>
                        <b-col md="5">
                            <gofix-text-field label="Date Issued Budget" oneline>{{ Item.issue_date_budget ? Item.issue_date_budget : null | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}</gofix-text-field>
                        </b-col>
                         <b-col md="3">
                            <gofix-text-field label="Chargeable" oneline>{{ Item.is_charge_customer ? "Yes" : "No" }}</gofix-text-field>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3" v-if="Item.module_type && Item.module_type.toLowerCase() == 'wsh'">
                        <b-col md="4" class="work-order-info-col-1">
                            <gofix-text-field label="Property Manager" oneline>{{ Item.property_manager && Item.property_manager.id ? Item.property_manager.name : null }}</gofix-text-field>
                        </b-col>
                        <b-col md="5">
                            <gofix-text-field label="Contractor Supervisor" oneline>{{ Item.contractor_supervisor && Item.contractor_supervisor.id ? Item.contractor_supervisor.name : null }}</gofix-text-field>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="8" class="work-order-info-col-1">
                            <gofix-text-field label="Description" oneline><span v-html="Item.remark && Item.remark.description ? Item.remark.description.replaceAll('\n', '<br>') : ''"></span></gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="3">
                    <gofix-text-field class="mb-3 editEndValue" label="Case:" oneline v-if="Item.order_type === 'RWO' && Item.cases">
                        <router-link :to="`/v2/case/${Item.cases.id}`" class="custom-link text-decoration-underline">{{Item.cases.case_number ? Item.cases.case_number : '' }}</router-link>
                    </gofix-text-field>
                    <div class="mb-3 width-full editEndValue">
                        <box-photo 
                            :attachments="attachments" 
                            :limit-photo="5" 
                            :open="modals.photo.open"
                            v-model="modals.photo.open"
                            :loading="modals.photo.loading"
                            :editing="$checkRole(this.$accessModule.order_tabs.main_info, 'update') || $checkRole(this.$accessModule.order_tabs.main_info, 'create')"
                            @upload-photo="uploadPhotos">
                        </box-photo>
                    </div>
                </b-col>
            </b-row>
            
        </gofix-card>
        <!--Info-->
        <b-modal :no-close-on-backdrop="true"
                 title="Work Order Info"
                 hide-footer
                 :centered="true"
                 modal-class="modal-create"
                 v-model="modals.info.open"
                 ref="edit-equipment"
                 @shown="shownModalInfo"
        >
            <b-form class="formV2" v-bind:class="{'run-loading':modals.info.loading}">
                <b-row>
                    <b-col md="6">
                        <gofix-form-tree
                                label="Service Category"
                                :default-expand-level="1"
                                :multiple="false"
                                :options="modals.info.serviceCategories"
                                :load-options="loadOptionServices"
                                search-nested
                                v-model="modals.info.data.service_category"
                                :normalizer="normalizerService"
                                placeholder=""
                                :disabled="(Item.order_status === 'Issued' || Item.order_status === 'Under Approval') ? false : true"
                                valueFormat="object">
                        </gofix-form-tree>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-dropdown
                                label="Fault Type"
                                v-model="modals.info.data.fault_type"
                                :options="modals.info.listFaultType"
                                placeholder=""
                                vLabel="fault_name">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6">
                        <gofix-form-dropdown
                                label="Priority"
                                v-model="modals.info.data.sla"
                                :options="modals.info.listSLA"
                                vLabel="priority">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="6">
                        <gofix-form-tree
                                label="Equipment Group"
                                :default-expand-level="1"
                                :options="modals.info.treeEquips"
                                :load-options="loadOptionsEquiment"
                                :normalizer="normalizerEquipment"
                                search-nested
                                valueFormat="object"
                                v-model="modals.info.data.equipment_type"
                                placeholder="Select"
                                ref="equipmentTree">
                        </gofix-form-tree>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12">
                        <gofix-form-input label="Description" v-model="modals.info.data.description"></gofix-form-input>
                    </b-col>
                    <b-col md="12">
                        <gofix-form-input-date
                            desc=""
                            v-model="modals.info.data.issue_date_budget"
                            label="Date Issued Budget">
                        </gofix-form-input-date>
                    </b-col>
                     <b-col md="12">
                        <b-form-checkbox v-model="modals.info.data.is_charge_customer" class="ml-3 checkbox-top-5"><span class="ml-3">Chargeable</span></b-form-checkbox>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="saveData" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!--Show all equipment (if equipment.lenght >= 9)-->
        <b-modal :no-close-on-backdrop="true" ref="modal-show-equips" title="Equipments" hide-footer :centered="true" id="modal-showEquips" v-model="modals.showAllEquipment.open">
            <ul class="list-equips-order">
                <template v-for="(eq, index) in Item.equipments">
                    <li><span>{{eq.tag_name}}</span></li>
                </template>
            </ul>
        </b-modal>
        <!--Edit equipments-->
        <b-modal :no-close-on-backdrop="true"
                 @shown="shownModalEditEquipment"
                 title="Edit Equipments" hide-footer :centered="true"
                 id="modal-equipsOrder" v-model="modals.editEquipment.open">
            <div class="boxModal" v-bind:class="{'run-loading':modals.editEquipment.loading}">
                <div class="title">Location Filter</div>
                <div class="contenAbsolute">
                    <div class="tree-view-properties    ">
                        <tree ref="treeLocationFilter" :data="modals.editEquipment.treeData" :options="modals.editEquipment.optsLocation" @node:clicked="selectLocation">
                            <div slot-scope="{ node }" class="node-container"> {{ node.text }} </div>
                        </tree>
                    </div>
                </div>
            </div>
            <div class="boxModal" v-bind:class="{'run-loading':modals.editEquipment.loading}">
                <div class="bottomDiv">
                    <ul class="list-unstyled listCheck">
                        <li>
                            <input class="styled-checkbox" type="checkbox" v-model="modals.editEquipment.checkAll" @change="selectAllEquipment">
                            <label></label>
                            <span>Select Equipments</span>
                        </li>
                        <template>
                            <li v-for="(eq, index) in modals.editEquipment.listItemEquipment" :key="index">
                                <input class="styled-checkbox" type="checkbox" :value="eq.id" v-model="modals.editEquipment.data.equipment_ids">
                                <label ></label>
                                <span>{{eq.tag_name}}</span>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>

            <b-button-group class="d-block text-right pr-3 clear-both">
                <gofix-button label="SUBMIT" @click="updateOrderEquipment" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>

</template>
<script>
    import { mapGetters } from 'vuex';
    import { LOAD_CHILDREN_OPTIONS  } from '@riophae/vue-treeselect';
    import LiquorTree from 'liquor-tree';
    const BoxPhoto = () => import('@/views/plugins/BoxPhoto.vue')
    import moment from 'moment';
    const simulateAsyncOperation = fn => {
        setTimeout(fn, 500)
    };
    export default {
        name: 'workOrderInfo',
        components: {
            [LiquorTree.name]: LiquorTree,
            BoxPhoto
        },
        data () {
            return {
                modals:{
                    info:{
                        open : false,
                        loading: false,
                        data:{
                            service_category:null,
                            fault_type:null,
                            sla:null,
                            equipment_type:null,
                            description:null,
                            issue_date_budget: null,
                            is_charge_customer: false
                        },
                        serviceCategories:[],
                        listSLA:[],
                        treeEquips:[],
                        listFaultType:[],
                    },
                    showAllEquipment : {
                        open: false
                    },
                    editEquipment : {
                        open: false,
                        loading: false,
                        checkAll: false,
                        data:{
                            equipment_ids:[],
                        },
                        treeData:[],
                        listItemEquipment:[],
                        optsLocation: {
                            minFetchDelay: 500,
                            fetchData: (node) => {
                                node.isBatch = false
                                return new Promise((resolve, reject) => {
                                    global.axios(`api/contracts/${this.Item.contract_id}/tree-properties/${node.data.id}`, {
                                        method: "GET",
                                        data: {},
                                        headers: {
                                            Accept: "application/json",
                                        }
                                    })
                                    .then(response => {
                                        resolve(response.data.data);
                                    })
                                    .catch(error => reject(error));
                              });
                            }
                        },
                    },
                    photoThumb : {
                        open:false
                    },
                    photo : {
                        open: false,
                        loading: false,
                        attachments: [],
                        attachment_del_ids: []
                    },
                },
                attachments: []
            }
        },
        watch: {
            $router: function(val) {
                this.attachments = [];
            },
            "Item.remark": function(val) {
                if(val) {
                    this.attachments = val.attachments;
                }
            },
            "Item.contract_id" : function (val) {
                this.loadRootServiceCategory();
                this.getEquipsType(0, val, 'all',true)
            },
            "modals.info.data.service_category" : function (val,old) {
                if(old){
                    if(val.id !== this.Item.service_category.id){
                        this.modals.info.data.sla = null;
                    }else{
                        this.modals.info.data.sla = this.Item.sla;
                    }
                    this.loadFaultType();
                    this.loadSLAByServiceCate(val.id);
                }
            },
            "modals.info.data.fault_type" : function (val, old) {
                if(val){
                    let is_reset_fault_type = (val && old && val.id && old.id && val.id != old.id) ? true : false;
                    this.loadSLAByServiceCate(this.modals.info.data.service_category.id, is_reset_fault_type);
                }
            },
            "modals.editEquipment.data.equipment_ids": function(val) {
                if(this.modals.editEquipment.listItemEquipment.length > val.length) {
                    this.modals.editEquipment.checkAll = false
                }
                if(val.length > 0 && this.modals.editEquipment.listItemEquipment.length === val.length) {
                    this.modals.editEquipment.checkAll = true
                }
            },
        },
        computed: {
            ...mapGetters({
                Item: 'OrderController/Item',
                IsReadOnly: 'OrderController/IsReadOnly',
            }),
        },
        created() {
            this.attachments = [];
            if(this.Item) {
                if(this.Item.id == this.$route.params.id) {
                    this.attachments = this.Item.remark ?  this.Item.remark.attachments : [];
                }
                this.loadRootServiceCategory();
                this.loadSLAByServiceCate();
                this.getEquipsType(0, this.Item.contract_id, 'all',true)
            }
            this.loadFaultType();
        },
        methods: {
            /*----- Update Order  -------------------------------------------------------*/
            async saveData(){
                if(this.modals.info.loading) return;
                let data = {};
                let bug = false;
                if(!this.modals.info.data.service_category){
                    bug = true;
                    this.$alertNotification("Please select a service category", "warning");
                }
                if(!this.modals.info.data.sla){
                    bug = true;
                    this.$alertNotification("Please select a priority", "warning");
                }
                if(bug) return ;
                data = {
                    service_category_id:this.modals.info.data.service_category.id,
                    fault_type_id:this.modals.info.data.fault_type ? this.modals.info.data.fault_type.id : null,
                    sla_id:this.modals.info.data.sla.id,
                    equipment_group_id:this.modals.info.data.equipment_type ? this.modals.info.data.equipment_type.id : null,
                    issue_date_budget:this.modals.info.data.issue_date_budget ? moment(this.modals.info.data.issue_date_budget).format("YYYY-MM-DD") : null,
                    is_charge_customer: this.modals.info.data.is_charge_customer,
                    remark : {
                        description : this.modals.info.data.description,
                        remark_type : 'OrderServiceRemark'
                    },
                    log:'work_order_info'
                };
                if(data.equipment_group_id !== this.Item.equipment_group_id){
                    data.equipment_ids = [];
                }
                this.modals.info.loading = true;
                this.$store.dispatch("OrderController/updateItem",{ id:this.Item.id, data: data })
                    .then(response => {
                        this.modals.info.open = false;
                        this.modals.info.loading = false;
                        this.$alertNotification(this.$notificationV2('editing', 'order'));
                    })
                    .catch(err => {
                        console.log(err);
                        this.modals.info.loading = false;
                    })
            },
            async updateOrderEquipment(){
                let data = {
                    equipment_ids : this.modals.editEquipment.data.equipment_ids,
                    log:'work_order_info_equipment'
                };
                this.modals.editEquipment.loading = true;
                this.$store.dispatch("OrderController/updateItem",{ id:this.Item.id, data: data })
                    .then(response => {
                        this.modals.editEquipment.open = false;
                        this.modals.editEquipment.loading = false;
                    })
                    .catch(err => {
                        console.log(err);
                        this.modals.editEquipment.loading = false;
                    });
            },

            /*-- Photo ----------------------------------------------------------*/
            async uploadPhotos(data){
                this.modals.photo.loading = true;
                var params = {
                    id: this.Item.id,
                    photos : data.attachments,
                    remark: {
                        description : this.Item.remark ? this.Item.remark.description : null,
                        remark_type : 'OrderServiceRemark'
                    }
                };
                if(data.attachment_del_ids.length > 0) {
                    /*await this.$store.dispatch("OrderController/deleteAttachments", { 
                        ids : data.attachment_del_ids,
                        action : 'order_service_remark' 
                    }).then(response => {})
                    .catch(err => {})*/
                    params.attachment_del_ids = data.attachment_del_ids;
                }
                await this.$store.dispatch("OrderController/updatePhotos", params)
                .then(response => {
                    this.modals.photo.loading = false;
                    this.modals.photo.open = false;
                    if(params.attachment_del_ids){
                        delete params.attachment_del_ids;
                    }
                    this.$alertNotification(this.$notificationV2('adding', 'attachment'));
                })
                .catch(err => {
                    console.log(err);
                    this.modals.photo.loading = false;
                });
            },

            /*--- Shown modals ---------------------------------------------------------*/
            shownModalInfo(){
                this.modals.info.data.service_category = this.Item.service_category;
                this.modals.info.data.sla = this.Item.sla;
                this.modals.info.data.equipment_type = this.Item.equipment_type;
                this.modals.info.data.fault_type = this.Item.fault_type;
                this.modals.info.data.description = this.Item.remark ? this.Item.remark.description : null;
                this.modals.info.data.issue_date_budget = this.Item.issue_date_budget ? moment(this.Item.issue_date_budget).toDate() : null;
                this.modals.info.data.is_charge_customer = this.Item.is_charge_customer || false;
                this.loadFaultType();
            },
            shownModalEditEquipment(){
                this.loadEquipmentList(this.Item.service_location);
                this.modals.editEquipment.data.equipment_ids = this.Item.equipment_ids || [];
            },

            /*-- Get Equipment ----------------------------------------------------------*/
            selectAllEquipment(){
                if (this.modals.editEquipment.checkAll) {
                    this.modals.editEquipment.data.equipment_ids = [];
                    this.modals.editEquipment.listItemEquipment.forEach((item) => {
                        this.modals.editEquipment.data.equipment_ids.push(item.id);
                    });
                } else {
                    this.modals.editEquipment.data.equipment_ids = [];
                }
            },
            async loadEquipmentList(property_id){
                if(!property_id) return ;
                this.modals.editEquipment.loading = true;
                let location = await global.axios(`api/contracts/${this.Item.contract_id}/properties/${property_id}`, {
                    method: "GET",
                    data: {},
                    headers: {
                        Accept: "application/json",
                    }
                });
                location.data.data.data = {
                    id: location.data.data.id,
                };
                location.data.data.state = {
                    selected: true
                };
                this.$refs.treeLocationFilter.setModel(location.data.data);
                await this.getEquipmentWithProperty(location.data.data.id);
                this.modals.editEquipment.loading = false;
            },
            selectLocation(node) {
                this.getEquipmentWithProperty(node.data.id);
            },
            async getEquipmentWithProperty(property_id) {
                await global.axios(`api/contracts/${this.Item.contract_id}/properties/${property_id}/equipment`, {
                    method: "GET",
                    params: {
                        equipment_group_id: this.Item.equipment_group_id,
                        equipment_status: 'Active'
                    },
                    headers: {
                        Accept: "application/json",
                    }
                })
                    .then(response => {
                        this.modals.editEquipment.listItemEquipment = response.data.data;
                    })
                    .catch(err => {
                        this.modals.editEquipment.listItemEquipment = [];
                    });
            },

            /*-- Get SLA ----------------------------------------------------------*/
            loadSLAByServiceCate(service_category_id = 0, is_reset_fault_type = false){
                if(!service_category_id) service_category_id = this.Item.service_category_id;
                this.$store.dispatch("v2SlaController/getSlaList", {
                    limit:-1,
                    page:1,
                    filter: {
                        service_category_id:service_category_id,
                        fault_type_id: this.modals.info.data.fault_type && this.modals.info.data.fault_type.id ? this.modals.info.data.fault_type.id : null 
                    },
                }).then(response => {
                    this.modals.info.listSLA = response.items;
                    if(this.modals.info.listSLA.length && is_reset_fault_type) {
                        let objTmp = this.modals.info.listSLA.filter(item => item.fault_types && item.fault_types.length > 0);
                        if(objTmp.length) {
                            this.modals.info.data.sla = objTmp[0];
                        } else {
                            if(this.modals.info.data.fault_type)
                                this.modals.info.data.sla = this.modals.info.listSLA[0];
                        }
                        
                    }
                });
            },

            /*-- Get Fault type ----------------------------------------------------------*/
            loadFaultType(){
                if(this.modals.info.data.service_category && this.modals.info.data.service_category.id) {
                    this.$store.dispatch("FaultTypeController/getItems", {
                        service_category_id: this.modals.info.data.service_category.id,
                    }).then(response => {
                        this.modals.info.listFaultType = response.items;
                    });
                }
            },

            /*-- Equipment type ----------------------------------------------------------*/
            async getEquipsType(parent_id, contract_id, node_type,set = false) {
                let dataE = [];
                //this.loadings.equipment = true;
                await global.axios(`api/equipment/tree-structure/${parent_id}`, {
                    method: "GET",
                    params: {
                        contract_id: contract_id,
                        node_type: node_type
                    },
                    headers: { Accept: "application/json", }
                })
                    .then(response => {
                        dataE = response.data.data;
                        //this.loadings.equipment = false;
                    }).catch(error => {
                        //this.loadings.equipment = false;
                    });
                if(set){
                    this.modals.info.treeEquips = dataE;
                }else{
                    return dataE
                }
            },
            loadOptionsEquiment({ action, parentNode, callback }) {
                if (action === LOAD_CHILDREN_OPTIONS ) {
                    simulateAsyncOperation(async () => {
                        parentNode.children = await this.getEquipsType(parentNode.data.id, this.Item.contract_id, 'all')
                        callback()
                    })
                }
            },
            normalizerEquipment(node) {
                if(node.data.isBatch) {
                    return {
                        id: node.data.id,
                        label: node.data.name,
                        children: node.children
                    }
                }
                return {
                    id: node.id,
                    label: node.name,
                    children: undefined
                }
            },

            /*-- Service category ----------------------------------------------------------*/
            loadRootServiceCategory(){
                this.$store.dispatch('ServiveCategoryController/getServiceCategories', {
                    contractId: this.Item.contract_id,
                    categoryId: 0
                }).then(response => {
                    this.modals.info.serviceCategories = response;
                });
            },
            loadOptionServices({action, parentNode, callback}) {
                if (parentNode.isBatch) {
                    this.$store.dispatch("ServiveCategoryController/getServiceCategories", {
                        contractId: this.Item.contract_id,
                        categoryId: parentNode.id
                    }).then(data => {
                        parentNode.children = data;
                        callback();
                    })
                } else {
                    callback();
                }

            },
            normalizerService(node) {
                if (node.isBatch)
                    return {
                        label: node.name,
                        children: node.children
                    };
                return {
                    label: node.name,
                    children: undefined
                }
            },
        }
    }
</script>